/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePersonaGroupRequest,
  HTTPValidationError,
  PersonaGroupResponse,
  PersonaGroupUsersResponse,
  ResponseGetPersonaGroupsApiPersonaGroupsGet,
  UpdatePersonaGroupRequest,
} from '../models/index';
import {
    CreatePersonaGroupRequestFromJSON,
    CreatePersonaGroupRequestToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PersonaGroupResponseFromJSON,
    PersonaGroupResponseToJSON,
    PersonaGroupUsersResponseFromJSON,
    PersonaGroupUsersResponseToJSON,
    ResponseGetPersonaGroupsApiPersonaGroupsGetFromJSON,
    ResponseGetPersonaGroupsApiPersonaGroupsGetToJSON,
    UpdatePersonaGroupRequestFromJSON,
    UpdatePersonaGroupRequestToJSON,
} from '../models/index';

export interface CreatePersonaGroupApiPersonaGroupsPostRequest {
    createPersonaGroupRequest: CreatePersonaGroupRequest;
    xApiKey?: string | null;
}

export interface DeletePersonaGroupApiPersonaGroupsGroupIdDeleteRequest {
    groupId: number;
    xApiKey?: string | null;
}

export interface GetPersonaGroupApiPersonaGroupsGroupIdGetRequest {
    groupId: number;
    xApiKey?: string | null;
}

export interface GetPersonaGroupUsersApiPersonaGroupsGroupIdUsersGetRequest {
    groupId: number;
    xApiKey?: string | null;
}

export interface GetPersonaGroupsApiPersonaGroupsGetRequest {
    includeUsers?: boolean;
    includeRegions?: boolean;
    includeDevice?: boolean;
    includeAppParameters?: boolean;
    includeProxy?: boolean;
    includeClassifier?: boolean;
    xApiKey?: string | null;
}

export interface GetPersonaGroupsIdsApiPersonaGroupsIdsGetRequest {
    xApiKey?: string | null;
}

export interface UpdatePersonaGroupApiPersonaGroupsGroupIdPutRequest {
    groupId: number;
    updatePersonaGroupRequest: UpdatePersonaGroupRequest;
    xApiKey?: string | null;
}

/**
 * 
 */
export class PersonaGroupsApi extends runtime.BaseAPI {

    /**
     * Create a new persona group
     * Create Persona Group
     */
    async createPersonaGroupApiPersonaGroupsPostRaw(requestParameters: CreatePersonaGroupApiPersonaGroupsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaGroupResponse>> {
        if (requestParameters['createPersonaGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'createPersonaGroupRequest',
                'Required parameter "createPersonaGroupRequest" was null or undefined when calling createPersonaGroupApiPersonaGroupsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/persona-groups`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePersonaGroupRequestToJSON(requestParameters['createPersonaGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaGroupResponseFromJSON(jsonValue));
    }

    /**
     * Create a new persona group
     * Create Persona Group
     */
    async createPersonaGroupApiPersonaGroupsPost(requestParameters: CreatePersonaGroupApiPersonaGroupsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaGroupResponse> {
        const response = await this.createPersonaGroupApiPersonaGroupsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a persona group by ID
     * Delete Persona Group
     */
    async deletePersonaGroupApiPersonaGroupsGroupIdDeleteRaw(requestParameters: DeletePersonaGroupApiPersonaGroupsGroupIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling deletePersonaGroupApiPersonaGroupsGroupIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/persona-groups/{group_id}`;
        urlPath = urlPath.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete a persona group by ID
     * Delete Persona Group
     */
    async deletePersonaGroupApiPersonaGroupsGroupIdDelete(requestParameters: DeletePersonaGroupApiPersonaGroupsGroupIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deletePersonaGroupApiPersonaGroupsGroupIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific persona group by ID
     * Get Persona Group
     */
    async getPersonaGroupApiPersonaGroupsGroupIdGetRaw(requestParameters: GetPersonaGroupApiPersonaGroupsGroupIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaGroupResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getPersonaGroupApiPersonaGroupsGroupIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/persona-groups/{group_id}`;
        urlPath = urlPath.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaGroupResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific persona group by ID
     * Get Persona Group
     */
    async getPersonaGroupApiPersonaGroupsGroupIdGet(requestParameters: GetPersonaGroupApiPersonaGroupsGroupIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaGroupResponse> {
        const response = await this.getPersonaGroupApiPersonaGroupsGroupIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific persona group by ID
     * Get Persona Group Users
     */
    async getPersonaGroupUsersApiPersonaGroupsGroupIdUsersGetRaw(requestParameters: GetPersonaGroupUsersApiPersonaGroupsGroupIdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaGroupUsersResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getPersonaGroupUsersApiPersonaGroupsGroupIdUsersGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/persona-groups/{group_id}/users`;
        urlPath = urlPath.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaGroupUsersResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific persona group by ID
     * Get Persona Group Users
     */
    async getPersonaGroupUsersApiPersonaGroupsGroupIdUsersGet(requestParameters: GetPersonaGroupUsersApiPersonaGroupsGroupIdUsersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaGroupUsersResponse> {
        const response = await this.getPersonaGroupUsersApiPersonaGroupsGroupIdUsersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all persona groups with optional full user details  Args:     include_users: If True, returns PersonaGroupUsersResponse with full user details including regions.                   If False, returns PersonaGroupResponse with just user IDs.     include_regions: If True, returns PersonaGroupUsersResponse with full user details including regions.                   If False, returns PersonaGroupResponse with just user IDs.     include_device: If True, returns PersonaGroupUsersResponse with full user details including device info.                   If False, returns PersonaGroupResponse with just user IDs.     include_app_parameters: If True, returns PersonaGroupUsersResponse with full user details including app parameters.                   If False, returns PersonaGroupResponse with just user IDs.     include_proxy: If True, returns PersonaGroupUsersResponse with full user details including proxy.                   If False, returns PersonaGroupResponse with just user IDs.     include_classifier: If True, returns PersonaGroupUsersResponse with full user details including classifier.                   If False, returns PersonaGroupResponse with just user IDs.
     * Get Persona Groups
     */
    async getPersonaGroupsApiPersonaGroupsGetRaw(requestParameters: GetPersonaGroupsApiPersonaGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetPersonaGroupsApiPersonaGroupsGet>> {
        const queryParameters: any = {};

        if (requestParameters['includeUsers'] != null) {
            queryParameters['include_users'] = requestParameters['includeUsers'];
        }

        if (requestParameters['includeRegions'] != null) {
            queryParameters['include_regions'] = requestParameters['includeRegions'];
        }

        if (requestParameters['includeDevice'] != null) {
            queryParameters['include_device'] = requestParameters['includeDevice'];
        }

        if (requestParameters['includeAppParameters'] != null) {
            queryParameters['include_app_parameters'] = requestParameters['includeAppParameters'];
        }

        if (requestParameters['includeProxy'] != null) {
            queryParameters['include_proxy'] = requestParameters['includeProxy'];
        }

        if (requestParameters['includeClassifier'] != null) {
            queryParameters['include_classifier'] = requestParameters['includeClassifier'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/persona-groups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetPersonaGroupsApiPersonaGroupsGetFromJSON(jsonValue));
    }

    /**
     * Get all persona groups with optional full user details  Args:     include_users: If True, returns PersonaGroupUsersResponse with full user details including regions.                   If False, returns PersonaGroupResponse with just user IDs.     include_regions: If True, returns PersonaGroupUsersResponse with full user details including regions.                   If False, returns PersonaGroupResponse with just user IDs.     include_device: If True, returns PersonaGroupUsersResponse with full user details including device info.                   If False, returns PersonaGroupResponse with just user IDs.     include_app_parameters: If True, returns PersonaGroupUsersResponse with full user details including app parameters.                   If False, returns PersonaGroupResponse with just user IDs.     include_proxy: If True, returns PersonaGroupUsersResponse with full user details including proxy.                   If False, returns PersonaGroupResponse with just user IDs.     include_classifier: If True, returns PersonaGroupUsersResponse with full user details including classifier.                   If False, returns PersonaGroupResponse with just user IDs.
     * Get Persona Groups
     */
    async getPersonaGroupsApiPersonaGroupsGet(requestParameters: GetPersonaGroupsApiPersonaGroupsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetPersonaGroupsApiPersonaGroupsGet> {
        const response = await this.getPersonaGroupsApiPersonaGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all persona group IDs
     * Get Persona Groups Ids
     */
    async getPersonaGroupsIdsApiPersonaGroupsIdsGetRaw(requestParameters: GetPersonaGroupsIdsApiPersonaGroupsIdsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number | null>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/persona-groups/ids`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all persona group IDs
     * Get Persona Groups Ids
     */
    async getPersonaGroupsIdsApiPersonaGroupsIdsGet(requestParameters: GetPersonaGroupsIdsApiPersonaGroupsIdsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number | null>> {
        const response = await this.getPersonaGroupsIdsApiPersonaGroupsIdsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing persona group
     * Update Persona Group
     */
    async updatePersonaGroupApiPersonaGroupsGroupIdPutRaw(requestParameters: UpdatePersonaGroupApiPersonaGroupsGroupIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PersonaGroupResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling updatePersonaGroupApiPersonaGroupsGroupIdPut().'
            );
        }

        if (requestParameters['updatePersonaGroupRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePersonaGroupRequest',
                'Required parameter "updatePersonaGroupRequest" was null or undefined when calling updatePersonaGroupApiPersonaGroupsGroupIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xApiKey'] != null) {
            headerParameters['x-api-key'] = String(requestParameters['xApiKey']);
        }


        let urlPath = `/api/persona-groups/{group_id}`;
        urlPath = urlPath.replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePersonaGroupRequestToJSON(requestParameters['updatePersonaGroupRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PersonaGroupResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing persona group
     * Update Persona Group
     */
    async updatePersonaGroupApiPersonaGroupsGroupIdPut(requestParameters: UpdatePersonaGroupApiPersonaGroupsGroupIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PersonaGroupResponse> {
        const response = await this.updatePersonaGroupApiPersonaGroupsGroupIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
